import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Tabs, TabLink, TabContent, TabButton } from 'components/tabs'
import CSSModules from 'react-css-modules'
import Modalizer from 'components/modalizer/modalizer'
import ShareEmail from 'components/share/share_email/share_email'
import ShareSocial from 'components/share/share_social/share_social'
import ShareLink from 'components/share/share_link/share_link'
import ShareEmbed from 'components/share/share_embed/share_embed'
import { QuestionIcon } from 'components/icon'
import GoogleClassroom from 'decorators/google_classroom_decorator/GoogleClassroom'
import DateRangePicker from 'components/date_range_picker/date_range_picker'
import { Tooltip } from 'components/tooltip'
import { SecondaryButton } from 'components/button'

import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import myLibraryStudentPacedSingleCodeSelector from 'redux/selectors/my_library/my_library_student_paced_single_code_selector'
import { dateFormatFromTimestamp, dateFormatTimestampFromArray, dateFormatArrayFromTimestamp, formatRemainingTime } from 'helpers/dateFormat/dateFormat'
import { localize } from 'helpers/translator'
import { validateEmail } from 'helpers/validations'
import { shareRemind } from 'helpers/social/remind'
import myLibraryActions from 'redux/actions/my_library_actions'
import generalActions from 'redux/actions/generalActions'
import shareActions from 'redux/actions/shareActions'
import sessionTypes from 'helpers/enums/sessionTypes'

import styles from './my_library_launch_homework.scss'
import classNames from 'classnames'
import Toggle from 'components/toggle/toggle'

class StudentPacedLaunchModal extends PureComponent {

	constructor() {
		super()
		this.state = {
			selectedMainTab: '',
			selectedEmbedRadio: '',
			emailHint: '',
			calendarOpened: false,
			temporaryExpireTime: 0,
		}
		this.changeTab			= this.changeTab.bind(this)
		this.handleRemindAction	= this.handleRemindAction.bind(this)
		this.handleToggleCalendar = this.handleToggleCalendar.bind(this)
		this.handleSaveExpirationDate = this.handleSaveExpirationDate.bind(this)
		this.dateChangeHandler = this.dateChangeHandler.bind(this)
		this.handleCancelDate = this.handleCancelDate.bind(this)
		this.handleEmailSubmit = this.handleEmailSubmit.bind(this)
		this.sessionSharedToMicrosoftTeams = this.sessionShared.bind(this, 'Microsoft Teams')
	}

	changeTab(value, type) {
		if (type === 'main_tab') {
			this.setState({
				selectedMainTab: value,
			})
		}

		if (type === 'embed_radio') {
			this.setState({
				selectedEmbedRadio: value,
			})
		}
	}

	componentDidMount() {
		//this.changeTab('email', 'main_tab')
		this.changeTab('Small', 'embed_radio')
		this.setState({
			temporaryExpireTime: this.props.sessionData.expire_time,
		})

		this.props.actions.launchHomeworkInitialize()
	}

	componentWillUnmount() {
		this.props.actions.launchHomeworkUnmount()
	}

	isTabVisible(tab) {
		return (this.state.selectedMainTab === tab)
	}

	handleEmailSubmit(values) {
		return new Promise((resolve, reject) => {
			if (!validateEmail(values.email)) {
				this.props.actions.openMessage(
					{
						alertImage: 'ic_share',
						alertTitle: localize('share_invalid_email'),
						singleButton: true,
						alertMessage: values.email,
						buttons: [
							{
								buttonName: 'OK',
							},
						],
					},
					'alert')
				reject()
			} else {
				this.props.actions.sendShareEmailSelfPacedForm(values.email, this.props.presentationUid, this.props.sessionData.pincode)
				resolve()
			}
		})
	}

	getExternalClient() {
		let sharingUrl = 'mailto:?'
		const emailData = this.props.sessionData.messages.email
		sharingUrl+='subject='+encodeURIComponent(emailData.subject_plain)
		sharingUrl+='&body='+encodeURIComponent(emailData.message_plain)
		return sharingUrl
	}

	getExternalOutlook() {
		let sharingUrl = 'https://outlook.live.com/owa/?path=/mail/action/compose'
		const emailData = this.props.sessionData.messages.email
		sharingUrl+='&subject=' + encodeURIComponent(emailData.subject_plain)
		sharingUrl+='&body=' + encodeURIComponent(emailData.message_plain)
		return sharingUrl
	}

	getExternalGmail() {
		let sharingUrl = 'https://mail.google.com/mail/?view=cm&fs=1&shva=1&ui=2&tf=1'
		const emailData = this.props.sessionData.messages.email
		sharingUrl+='&su='+encodeURIComponent(emailData.subject_plain)
		sharingUrl+='&body='+encodeURIComponent(emailData.message_plain)
		return sharingUrl
	}

	getExternalYahoo() {
		const emailData = this.props.sessionData.messages.email
		let message = '', subject = ''
		subject = emailData.subject_plain.replace(/'/g, ' ')
		message = emailData.message_plain.replace(/'/g, ' ')

		subject = subject.replace(/"/g, ' ')
		subject = subject.replace(/¨/g, ' ')
		subject = subject.replace(/\n/g, ' ')

		message = message.replace(/"/g, ' ')
		message = message.replace(/¨/g, ' ')
		message = message.replace(/\n/g, ' ')


		let sharingUrl = 'http://compose.mail.yahoo.com/?'
		sharingUrl+='subject='+encodeURIComponent(subject)
		sharingUrl+='&body='+encodeURIComponent(message)
		return sharingUrl
	}

	getExternalLink = type => {
		if (type === 'gmail') {
			return this.getExternalGmail()
		} else if (type === 'yahoo') {
			return this.getExternalYahoo()
		} else if (type === 'outlook') {
			return this.getExternalOutlook()
		} else if (type === 'client') {
			return this.getExternalClient()
		}
		return 'https://github.com'
	}

	handleRemindAction() {
		shareRemind(this.props.sessionData.messages.remind.url, this.props.sessionData.messages.remind.text)
	}

	toggleCalendar() {
		this.setState(prevState => ({
			calendarOpened: !prevState.calendarOpened,
		}))
	}

	handleToggleCalendar() {
		this.setState({
			temporaryExpireTime: this.props.sessionData.expire_time,
		})
		this.toggleCalendar()
	}

	handleSaveExpirationDate() {
		this.props.actions.saveExpirationDate(this.props.sessionData.session_uid, this.state.temporaryExpireTime, this.props.sessionData.expire_time) //todo: faltan params
		this.toggleCalendar()
	}

	dateChangeHandler(expireTime) {
		this.setState({
			temporaryExpireTime: dateFormatTimestampFromArray(expireTime),
		})
	}

	handleCancelDate() {
		this.handleToggleCalendar()
	}

	closeModal = () => {
		this.props.actions.closeModal(this.props.modalName)
	}

	handleSelect = (selectedTab, namespace) => {
		this.changeTab(selectedTab, namespace)
	}

	sessionShared = method => {
		this.props.actions.sessionShared(method, this.props.presentationUid, 'Student Paced')
	}

	toggleRequiredSubmissions = value =>
		this.props.actions.toggleRequiredSubmissions(this.props.sessionData.session_uid, value)

	viewSessionProgress = () => {
		this.props.actions.resumeActiveSession(this.props.presentationUid, this.props.sessionData.session_uid, sessionTypes.HOMEWORK)
	}

	render() {
		const expiresIn = formatRemainingTime(this.props.sessionData.launched_time, this.state.temporaryExpireTime, this.props.actualTimestamp)
		return (
			<Modalizer nopadding={true} closeAction={this.closeModal}>
				<div styleName='code-expiration-text'>
					<p styleName='title'>{localize('homework_share_code_text2')}</p>
					<p styleName='code'>{this.props.sessionData.pincode.toUpperCase()}</p>
					{ this.props.canAccessStudentSubmissions &&
						<div
							styleName='student-submissions'
						>
							<Toggle
								value={this.props.sessionData.is_submission_required}
								onChange={this.toggleRequiredSubmissions}
							/>
							<div styleName='student-submissions-label'>
								{ this.props.shouldShowNewRequiredSubmissionsMessage
									? localize('requiredActivitiesAndSkipping_toggle_label')
									: localize('requiredActivities_toggle_label')
								}
							</div>
						</div>
					}
					{
						this.props.sessionData.launched_time && this.props.sessionData.expire_time &&
							<p styleName='text'>{localize('my_library_student_paced_launch_modal_valid_from')+' '+dateFormatFromTimestamp(this.props.sessionData.launched_time)+' '+localize('my_library_student_paced_launch_modal_valid_to')+' '+dateFormatFromTimestamp(this.props.sessionData.expire_time)} <span styleName='icon-question'> <a href='https://youtu.be/feezTVL-oP4' target='blank'> <QuestionIcon /> </a> </span> </p>
					}
					<div onClick={this.handleToggleCalendar} styleName='date'>

						<p styleName='date-text'>{`${expiresIn} ${localize('code_list_remaining')}`}</p>
						<span styleName='icon-date'>
							<svg width="17" height="17"><defs><mask id="a" x="0" y="0" width="17" height="17" maskUnits="userSpaceOnUse"><path fill="#fff" d="M0 .04h17V17H0V.04z"/></mask><mask id="b" x="0" y=".04" width="17" height="16.96" maskUnits="userSpaceOnUse"><path fill="#fff" d="M0 .04h17V17H0V.04z"/></mask><mask id="c" x="0" y=".04" width="17" height="16.96" maskUnits="userSpaceOnUse"><path fill="#fff" d="M0 .04h17V17H0V.04z"/></mask></defs><g mask="url(#a)"><path className="color-change" d="M12.67 3.94h.24a.68.68 0 0 0 .67-.68V.68a.67.67 0 0 0-.67-.68h-.24a.67.67 0 0 0-.67.68v2.58a.68.68 0 0 0 .67.68z" fill="#0099e6"/></g><g mask="url(#a)"><path className="color-change" d="M4.17 3.94h.24a.68.68 0 0 0 .67-.68V.68A.67.67 0 0 0 4.41 0h-.24a.67.67 0 0 0-.67.68v2.58a.68.68 0 0 0 .67.68z" fill="#0099e6"/></g><g mask="url(#b)"><path className="color-change" d="M15.91 1.44h-1.72v2A1.08 1.08 0 0 1 13 4.53h-.24a1.23 1.23 0 0 1-1.24-1.23V1.44H5.61v1.87A1.23 1.23 0 0 1 4.4 4.55h-.25a1.23 1.23 0 0 1-1.21-1.24V1.44H1.09A1.09 1.09 0 0 0 0 2.54V15.9A1.1 1.1 0 0 0 1.09 17h14.82A1.1 1.1 0 0 0 17 15.9V2.54a1.09 1.09 0 0 0-1.09-1.1zm0 14.46H1.09V5.81h14.82V15.9z" fill="#0099e6"/></g><g mask="url(#c)"><path className="color-change" d="M9.13 9h1.74a.13.13 0 0 0 .13-.14V7.14a.13.13 0 0 0-.13-.14H9.13a.13.13 0 0 0-.13.14v1.72a.13.13 0 0 0 .13.14z" fill="#0099e6"/></g><g mask="url(#c)"><path className="color-change" d="M12.13 9h1.74a.13.13 0 0 0 .13-.14V7.14a.13.13 0 0 0-.13-.14h-1.74a.13.13 0 0 0-.13.14v1.72a.13.13 0 0 0 .13.14z" fill="#0099e6"/></g><g mask="url(#c)"><path className="color-change" d="M2.13 12h1.74a.13.13 0 0 0 .13-.14v-1.72a.13.13 0 0 0-.13-.14H2.13a.13.13 0 0 0-.13.14v1.72a.13.13 0 0 0 .13.14z" fill="#0099e6"/></g><g mask="url(#c)"><path className="color-change" d="M5.13 12h1.74a.13.13 0 0 0 .13-.14v-1.72a.13.13 0 0 0-.13-.14H5.13a.13.13 0 0 0-.13.14v1.72a.13.13 0 0 0 .13.14z" fill="#0099e6"/></g><g mask="url(#c)"><path className="color-change" d="M9.13 12h1.74a.13.13 0 0 0 .13-.14v-1.72a.13.13 0 0 0-.13-.14H9.13a.13.13 0 0 0-.13.14v1.72a.13.13 0 0 0 .13.14z" fill="#0099e6"/></g><g mask="url(#c)"><path className="color-change" d="M12.13 12h1.74a.13.13 0 0 0 .13-.14v-1.72a.13.13 0 0 0-.13-.14h-1.74a.13.13 0 0 0-.13.14v1.72a.13.13 0 0 0 .13.14z" fill="#0099e6"/></g><g mask="url(#c)"><path className="color-change" d="M3.87 13H2.13a.13.13 0 0 0-.13.14v1.72a.13.13 0 0 0 .13.14h1.74a.13.13 0 0 0 .13-.14v-1.72a.13.13 0 0 0-.13-.14z" fill="#0099e6"/></g><g mask="url(#c)"><path className="color-change" d="M6.87 13H5.13a.13.13 0 0 0-.13.14v1.72a.13.13 0 0 0 .13.14h1.74a.13.13 0 0 0 .13-.14v-1.72a.13.13 0 0 0-.13-.14z" fill="#0099e6"/></g><g mask="url(#c)"><path className="color-change" d="M10.87 13H9.13a.13.13 0 0 0-.13.14v1.72a.13.13 0 0 0 .13.14h1.74a.13.13 0 0 0 .13-.14v-1.72a.13.13 0 0 0-.13-.14z" fill="#0099e6"/></g><g mask="url(#c)"><path className="color-change" d="M13.87 13h-1.74a.13.13 0 0 0-.13.14v1.72a.13.13 0 0 0 .13.14h1.74a.13.13 0 0 0 .13-.14v-1.72a.13.13 0 0 0-.13-.14z" fill="#0099e6"/></g></svg>
						</span>
						<div styleName='date-tooltip'>
							<Tooltip arrow='top-center'>{localize('code_list_tooltip')}</Tooltip>
						</div>
					</div>
					<div styleName='btn-join'>
						{ this.props.canAccessProgress &&
							<div styleName='btn-join-element'>
								<SecondaryButton onClick={this.viewSessionProgress} >
									{localize('myLibrary_studentPaced_viewProgress')}
								</SecondaryButton>
							</div>
						}
					</div>
				</div>
				{this.state.calendarOpened &&
					<div styleName='content-datepicker'>
						<DateRangePicker
							startDate={dateFormatArrayFromTimestamp(this.props.sessionData.launched_time)}
							endDate={dateFormatArrayFromTimestamp(this.state.temporaryExpireTime)}
							minimumNights={1}
							maxDays={365}
							saveHandler={this.handleSaveExpirationDate}
							cancelHandler={this.handleCancelDate}
							dateChangeHandler={this.dateChangeHandler}
						/>
					</div>
				}
				{!this.state.calendarOpened &&
					<div styleName={classNames({
						main: true,
						'main--expanded': !!this.state.selectedMainTab,
					})} >
						<Tabs
							name = 'main_tab'
							handleSelect = {this.handleSelect}
							selectedTab = {this.state.selectedMainTab}
							activeLinkStyle = {{}}
							activeClassStyle = {styles.active_tab_item}
						>

							<div styleName='tab'>
								<TabLink to='email' styleName='tab_item'><div className={styles.share_email}>{localize('share_email')}</div></TabLink>
								<TabLink to='social' styleName='tab_item'><div className={styles.share_social}>{localize('share_social')}</div></TabLink>
								<TabLink to='link' styleName='tab_item'><div className={styles.share_link}>{localize('share_link')}</div></TabLink>
								{ this.props.sessionData.messages.embed &&
									<TabLink to='embed' styleName='tab_item'><div className={styles.share_embed}>{localize('share_embed')}</div></TabLink>
								}
								<TabButton styleName='tab_item'>
									<div className={styles.share_google}>
										<div className={styles['share_google-image']}></div>
										<div className={styles['custom-label']}>{localize('share_google')}</div>
										<GoogleClassroom
											urlWeb={this.props.sessionData.messages.googleClassroom.urlWeb}>
											<div className={styles['hidden-icon']}></div>
										</GoogleClassroom>
									</div>
								</TabButton>
								<TabButton onClick={this.handleRemindAction} styleName='tab_item'>
									<div className={styles.share_remind}>{localize('share_remind')}</div>
								</TabButton>
								<TabButton styleName='tab_item'>
									<div className={styles.share_teams}>
										<div className={styles['share_teams-image']}></div>
										<div
											className={`teams-share-button ${styles['hidden-icon']}`} //used by Microsoft script to handle the sharing process
											data-href={this.props.sessionData.messages.microsoftTeams.urlWeb}
											data-icon-px-size='57'
											onClick={this.sessionSharedToMicrosoftTeams} >
										</div>
										<div className={styles['custom-label']}>{localize('share_microsoft')}</div>
									</div>
								</TabButton>
							</div>

							<div styleName='tabs-content'>
								<div styleName='tabs-content-share'>
									<TabContent for='email'>
										<ShareEmail
											visibleTab={this.isTabVisible('email', this.state.selectedMainTab)}
											onFormSubmit={this.handleEmailSubmit}
											getExternalLink={this.getExternalLink}
											emailHint={this.state.emailHint}
										/>
									</TabContent>

									<TabContent for='social'>
										<ShareSocial
											visibleTab={this.isTabVisible('social', this.state.selectedMainTab)}
											dataObject={this.props.sessionData.messages.social} />
									</TabContent>

									<TabContent for='link'>
										<ShareLink
											visibleTab={this.isTabVisible('link', this.state.selectedMainTab)}
											payload={this.props.sessionData.messages.link} />
									</TabContent>

									{this.props.sessionData.messages.embed &&
										<TabContent for='embed'>
											<ShareEmbed
												visibleTab={this.isTabVisible('embed', this.state.selectedMainTab)}
												onTabChange={selectedTab => {
													this.changeTab(selectedTab, 'embed_radio')
												}}
												selectedEmbedRadio={this.state.selectedEmbedRadio}
												payload={this.props.sessionData.messages.embed} />
										</TabContent>
									}
								</div>
							</div>
						</Tabs>
					</div>
				}
			</Modalizer>
		)
	}

}

StudentPacedLaunchModal.propTypes = {
	canAccessStudentSubmissions: PropTypes.bool,
	canAccessProgress: PropTypes.bool,
	shouldShowNewRequiredSubmissionsMessage: PropTypes.bool,
}

StudentPacedLaunchModal.defaultProps = {
	canAccessStudentSubmissions: false,
	canAccessProgress: false,
	shouldShowNewRequiredSubmissionsMessage: false,
}

function mapStateToProps(state, ownProps) {
	return myLibraryStudentPacedSingleCodeSelector(ownProps.sessionUid, ownProps.presentationUid)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		launchHomeworkInitialize: myLibraryActions.launchHomeworkInitialize,
		openMessage: generalActions.openMessage,
		sendShareEmailSelfPacedForm: shareActions.sendShareEmailSelfPacedForm,
		closeModal: generalActions.closeModal,
		saveExpirationDate: myLibraryActions.saveExpirationDate,
		launchHomeworkUnmount: myLibraryActions.launchHomeworkUnmount,
		sessionShared: myLibraryActions.sessionShared,
		toggleRequiredSubmissions: myLibraryActions.toggleRequiredSubmissions,
		resumeActiveSession: myLibraryActions.resumeActiveSession,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(StudentPacedLaunchModal, styles, {allowMultiple: true}))
export { StudentPacedLaunchModal }
